module.exports = __webpack_public_path__ + "img/face.4cc8ffbc.png";